<template>
	<div class="login-page">
		<div class="login-lang-switch">
			<el-dropdown trigger="click" placement="bottom" @command="changeLanguage">
				<span class="lang-switch-link">
					<img class="lang-switch-icon" src="../assets/img/lang.png" alt="" />
					<span class="lang-switch-text">{{ currentLangLabel }}</span>
					<i class="el-icon-arrow-down"></i>
				</span>
				<el-dropdown-menu slot="dropdown" class="login-lang-dropdown">
					<el-dropdown-item command="zh_CN" :class="{ active: $i18n.locale !== 'en' }">{{ $t('Simplified Chinese') }}</el-dropdown-item>
					<el-dropdown-item command="en" :class="{ active: $i18n.locale === 'en' }">{{ $t('English') }}</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>

		<div class="auth-layout">
			<aside class="auth-brand">
				<div class="auth-brand__inner">
					<!-- 品牌图先空置 -->
					<span class="auth-brand__logo auth-brand__logo--empty" aria-hidden="true">
						<img src="../assets/img/avatar.png" alt="" style="width: 120px; height: 120px;">
					</span>
					<h2 class="auth-brand__slogan">{{ $t('loginSlogan') }}</h2>
					<p class="auth-brand__subtitle">{{ $t('loginSubtitle') }}</p>
				</div>
			</aside>
			<main class="auth-main">
				<div class="auth-card">
					<el-form :model="form" :rules="rules" ref="ruleForm" class="auth-form">
						<h3 class="auth-card__title">{{ $t('Sign in/Sign up') }}</h3>
						<div class="auth-tabs">
							<span @click="chcode" :class="{ active: code }">{{ $t('Verification Code') }}</span>
							<span @click="chpass" :class="{ active: pass }">{{ $t('Passwordon') }}</span>
						</div>
						<el-form-item prop="phone">
							<el-input
								oninput="value=value.replace(/\D/gi,'')"
								:placeholder="$t('Phone number')"
								v-model="form.phone"
								:maxlength="max"
								class="auth-input input-with-select"
							>
								<el-select
									v-model="form.countryIndex"
									slot="prepend"
									class="country-select"
									@change="changeCode"
								>
									<div class="el-input_search">
										<img src="../assets/img/search.svg" alt="" />
										<input
											type="text"
											:placeholder="$t('searchArea')"
											class="el-input__inner"
											v-model="dropDownValue"
											@keyup="dropDownSearch"
										/>
									</div>
									<el-option
										v-for="(item, index) in countries"
										:label="`+${item.country_code } ${ item.name} `"
										:key="item.id"
										:value="item.id"
									>
										<span>+{{ item.country_code }} {{ item.name }}</span>
									</el-option>
								</el-select>
							</el-input>
						</el-form-item>

						<el-form-item v-if="code" prop="verification">
							<el-input
								maxlength="6"
								:placeholder="$t('Verification code')"
								v-model="form.verification"
								oninput="value=value.replace(/\D/gi,'')"
								class="auth-input input-with-send"
							>
								<el-button slot="append" @click="submit">
									<span v-if="time==0">{{ $t('Send') }}</span>
									<span v-else>{{ time }} s</span>
								</el-button>
							</el-input>
						</el-form-item>

						<el-button
							v-if="code"
							class="auth-submit"
							type="primary"
							@click="verifyClick"
						>{{ $t('Continue') }}</el-button>

						<el-form-item v-if="pass" prop="password">
							<el-input
								:type="flagType"
								:placeholder="$t('Password')"
								v-model="form.password"
								class="auth-input input-with-pass"
							>
								<img
									@click="getFlag()"
									slot="suffix"
									:src="flag ? see : nosee"
									class="password-eye"
									alt=""
								/>
							</el-input>
						</el-form-item>

						<el-button
							v-if="pass"
							class="auth-submit"
							type="primary"
							@click="submitForm()"
						>{{ $t('Continue') }}</el-button>

						<div class="auth-terms">
							<span>{{ $t('By continuing, you agree to our ') }}</span>
							<span class="auth-link" @click="toUserService">{{ $t('User Service Agreement') }}</span>
							<span>{{ $t('and') }}</span>
							<span class="auth-link" @click="toPolicy">{{ $t('Privacy Policy') }}</span>
						</div>
					</el-form>
				</div>
			</main>
		</div>
	</div>
</template>

<script>
import { verifyCodeLogin ,recordClick,verifyCode, getCountries,passLogin,checkUser} from '../api';
	import { loadingData, EventBus ,getTimeZoneCity } from '../utils';
	import { setStore, getStore, keys } from '../store';
	import { setUser } from '../store/user';
	import { LoginRedirect } from '../services/redirectService';
	import { resetDocumentFontSize, applyLocale } from '../utils/locale';

	import i18n from '../locales/i18n';

	export default {
		data() {
			return {
				form: {
					phone: '',
					countryIndex: '',
					code:'',
					verification:'',
					password:'',
				},
				countries: [],
				min:1,
				rules: {
					phone: [
						{ required: true, message: i18n.t('Please enter your mobile phone number'), trigger: 'blur' },
						{ min:6, message: i18n.t('Incorrect mobile number format'), trigger: 'blur' },
					],
					verification:[
						{ required: true, message: i18n.t('Please enter the verification code'), trigger: 'blur'  },
						{ max:6,min:6, message: i18n.t('The verification code format is incorrect'), trigger: 'blur' },
					],
					password:[
						{required:true,message: i18n.t('Please enter the password'), trigger: 'blur' }
					]
				},
				status:null,
				max:11,
				time:0,
				code:true,
				pass:false,
				 flag: false,
				flagType:'password',
				see:require('../assets/img/nosee.png'),
				nosee:require('../assets/img/see.png'),
				dropDownValue:'',
				qvhao: [],

			};
		},
		created(){
			resetDocumentFontSize(this.$i18n && this.$i18n.locale)
		},
		beforeDestroy() {
			resetDocumentFontSize(this.$i18n && this.$i18n.locale)
		},
		mounted() {
			loadingData(async () => {
				let result = await getCountries({});
				this.countries = result.map((item) => {
					return { id: item.id, name: item.name_zh, country_code: item.country_code };
				});
				this.qvhao=this.countries
				 this.form.countryIndex = this.countries[1].id
                this.form.code = this.countries[1].country_code
			});
			let user= getStore(keys.user)
			if(user.user_info){
				this.$router.push({ path: '/index' });
			}
		},
		computed:{
			currentLangLabel() {
				return this.$i18n.locale === 'en' ? 'En' : '中'
			},
		},
		methods: {
      changeLanguage(command) {
        if (!command || command === this.$i18n.locale) return
        applyLocale(command, this.$i18n)
        const query = Object.assign({}, this.$route.query, { lang: command })
        this.$router.replace({ query }).catch(() => {})
        location.reload()
      },
      toUserService() {
        window.open('/goods/service')
      },
      toPolicy() {
        window.open('/goods/police')
      },
			  getFlag(){
			this.flag = !this.flag
			this.flagType = this.flag ? 'text' : 'password'//text为显示密码；password为隐藏密码
			},
			chcode(){
				this.code=true;
				this.pass=false;
				this.$refs.ruleForm.resetFields();
			},
			chpass(){
				this.code=false;
				this.pass=true;
				this.$refs.ruleForm.resetFields();
			},
			changeCode(){
        this.countries.map((item) => {
            if(this.form.countryIndex == item.id){
                this.form.code = item.country_code
            }
        });
        if(this.form.code=='86'){

		  if(this.form.phone.length>11){
            this.form.phone = ''
          }

          this.max = 11
		//   this.rules.phone[1].min = 1
        }else if(this.form.code=='1'){
          if(this.form.phone.length>10){
            this.form.phone = ''
          }
          this.max = 10

        }else{
			this.max=15

		}
      },
	     //验证码
			submit() {
				// this.countryFc()
				this.$refs.ruleForm.validateField ("phone", (valid) => {
					if (!valid) {
						if(this.time!=0){
							this.$message(i18n.t('还在有效期内'));
							return
						}
						loadingData(async () => {
							// let countryCode = this.form.code;
							let checkphone=await checkUser(this.form.phone, this.form.code);
						 console.log(checkphone)
						 if(checkphone.is_exist=='0'){

							//  this.$router.push({
							// 	name: 'newUser',
							// 	params: {
							// 		phone: this.form.phone,
							// 		country_code: this.form.code,
							// 	},
							// });
							this.$message({
								  message: i18n.t('User Does Not Exist'),
								  type: 'warning',
								  customClass:'messageclass',
								//   center: true
							  });
							return false
						 }
							await verifyCode(this.form.phone, this.form.code);

							this.time=60;
							let distime= setInterval(() => {
								if(this.time==0){
									clearInterval(distime);
								}
								else{
								     this.time=this.time-1;
							    }
						}, 1000);
							// this.$router.push({
							// 	name: 'verify',
							// 	params: {
							// 		phone: this.form.phone,
							// 		country_code: this.form.code,
							// 	},
							// 	query: this.$route.query,
							// });
						});
					}
				});
			},
			//密码登录
			async  submitForm() {
				var that =this
				 await this.$refs.ruleForm.validate ((valid) => {
					if(valid){
						loadingData(async () => {
						try {
							// alert(getTimeZoneCity())

						let userInfo = await passLogin(that.form.phone, that.form.password, that.form.code,getTimeZoneCity());
						if(!userInfo||userInfo==''||userInfo==null){
							return false
						}
						if(userInfo=='Password input error'){
							this.$message({
								  message: i18n.t('Wrong password'),
								  type: 'error',
								  customClass:'dismessageclass',
							  });
							return false
						}
						setStore(keys.userInfo, userInfo);
						setStore(keys.token, userInfo.token);
						await setUser();
						EventBus.$emit('login');

						if (userInfo.is_register){
							// await recordClick(2,userInfo.user_sn);
						}
						setTimeout(() => {
							// if (userInfo.is_register)
							this.$router.push({ path: '/index' });
							// else {
							// 	LoginRedirect();
							// }
						}, 1000);
						}catch (error) {
						this.status = false;
					}

					});

					}
				});


			},
			//登录
			async  verifyClick() {
				var that =this
				 await this.$refs.ruleForm.validate ((valid) => {
					if(valid){
						loadingData(async () => {
						try {
							// alert(getTimeZoneCity())
						let userInfo = await verifyCodeLogin(that.form.phone, that.form.verification, that.form.code,getTimeZoneCity());
						if(!userInfo||userInfo==''||userInfo==null){
							that.form.verification=''
							return false
						}
						setStore(keys.userInfo, userInfo);
						setStore(keys.token, userInfo.token);
						await setUser();
						EventBus.$emit('login');

						if (userInfo.is_register){
							// await recordClick(2,userInfo.user_sn);
						}
						setTimeout(() => {
							// if (userInfo.is_register)
							this.$router.push({ path: '/index' });
							// else {
							// 	LoginRedirect();
							// }
						}, 1000);
						}catch (error) {
						this.status = false;
					}

					});

					}
				});


			},
			countryFc(){
				if(this.form.countryIndex==''){
					this.status=true;
					return false;
				}else{
					this.status=false
				}
			},
			dropDownSearch () {
				var _this = this
				if (_this.dropDownValue) {
					_this.countries = []
					_this.qvhao.find(item => {
					let name =  ' +' + item.country_code + item.name
					if (name.toLowerCase().indexOf(_this.dropDownValue.toLowerCase()) != -1) {
						_this.countries.push(item)
					}
					})
				} else {
					_this.countries = _this.qvhao
				}
				},
		},
	};
</script>

<style lang="less" scoped>
.login-page {
	min-height: 100vh;
	background-color: #f5f5f5;
	font-family: 'AlibabaPuHuiTi', 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	letter-spacing: normal;
	word-spacing: normal;
}

html[lang="en"] .login-page {
	/* 英文避免全局负字距 + 中文字体空格异常导致粘连 */
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC', 'Microsoft YaHei', 'AlibabaPuHuiTi', sans-serif;
	letter-spacing: normal;
	word-spacing: normal;
}

.login-lang-switch {
	position: fixed;
	top: 24px;
	right: 32px;
	z-index: 100;
}

.lang-switch-link {
	display: inline-flex;
	align-items: center;
	cursor: pointer;
	color: #b50604;
	font-size: 16px;
	line-height: 1;
	letter-spacing: normal;
}

.lang-switch-icon {
	width: 18px;
	height: 18px;
	margin-right: 6px;
	object-fit: contain;
	/* 白色图标转为品牌红 #B50604 */
	filter: brightness(0) saturate(100%) invert(14%) sepia(90%) saturate(6000%) hue-rotate(350deg) brightness(0.85) contrast(1.05);
}

.lang-switch-text {
	color: #b50604;
	font-weight: 500;
	margin-right: 4px;
}

.auth-layout {
	display: flex;
	min-height: 100vh;
	width: 100%;
}

.auth-brand {
	flex: 0 0 45%;
	max-width: 45%;
	/* 左侧背景图先空置，仅保留品牌色 */
	background-image: url('../assets/img/login_left_bg.png');
	background-size: 100% 100%;
	background-repeat: repeat;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 48px 40px;
	box-sizing: border-box;
}

.auth-brand__inner {
	max-width: 420px;
	text-align: center;
	color: #fff;
}

.auth-brand__logo {
	display: block;
	width: 120px;
	height: 120px;
	margin: 0 auto 32px;
	object-fit: contain;
}

.auth-brand__logo--empty {
	background: transparent;
}

.auth-brand__slogan {
	margin: 0 0 16px;
	font-size: 28px;
	font-weight: 600;
	line-height: 1.4;
	color: #fff;
	letter-spacing: normal;
	word-spacing: normal;
}

.auth-brand__subtitle {
	margin: 0;
	font-size: 16px;
	font-weight: 400;
	line-height: 1.6;
	opacity: 0.95;
	color: #fff;
	letter-spacing: normal;
	word-spacing: normal;
}

.auth-main {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 48px 32px;
	box-sizing: border-box;
    background-color: #f5f5f5;
    background-image: url(/par/static/img/login_right_bg.7f883b0.png);
    background-repeat: repeat;
    background-size: auto;
    background-position: 0 0;
}

.auth-card {
	width: 100%;
	max-width: 460px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 8px 32px rgba(16, 24, 40, 0.08);
	padding: 32px 36px 28px;
	box-sizing: border-box;
}

.auth-card__title {
	margin: 0 0 24px;
	font-size: 24px;
	font-weight: 600;
	line-height: 32px;
	text-align: center;
	color: #111827;
}

.auth-tabs {
	display: flex;
	margin-bottom: 28px;
	border-bottom: 1px solid #e5e7eb;
	gap: 8px;

	span {
		flex: 1;
		padding: 0 8px 12px;
		font-size: 14px;
		line-height: 22px;
		text-align: center;
		color: #9ca3af;
		cursor: pointer;
		border-bottom: 2px solid transparent;
		margin-bottom: -1px;
		letter-spacing: normal;
		word-spacing: normal;
		white-space: nowrap;

		&.active {
			color: #b50604;
			border-bottom-color: #b50604;
			font-weight: 500;
		}
	}
}

.auth-form {
	/deep/ .el-form-item {
		margin-bottom: 20px;
	}
}

.auth-input {
	width: 100%;

	/deep/ .el-input__inner {
		height: 44px;
		line-height: 44px;
		border: 1px solid #d1d5db;
		border-radius: 8px;
		font-size: 14px;
		color: #111827;
		padding: 0 14px;
	}

	/deep/ .el-input-group__append {
		background: #b50604;
		border: 1px solid #b50604;
		border-radius: 0 8px 8px 0;
		padding: 0;

		.el-button {
			margin: 0;
			height: 44px;
			padding: 0 18px;
			background: #b50604;
			border: none;
			color: #fff;
			font-size: 14px;
			border-radius: 0 8px 8px 0;
		}
	}
}

.input-with-select {
	&.el-input-group {
		width: 100%;
		border: 1px solid #d1d5db;
		border-radius: 8px;
		box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
		border-collapse: separate;
		border-spacing: 0;
		overflow: visible;
	}

	/deep/ .el-input-group__prepend {
		width: 136px;
		min-width: 136px;
		max-width: 136px;
		white-space: nowrap;
		vertical-align: middle;
		overflow: visible;
		background: #fff;
		border: none;
		border-right: 1px solid #d1d5db;
		border-radius: 8px 0 0 8px;
		padding: 0 6px;
		line-height: normal;
		box-sizing: border-box;
		text-align: left;
	}

	/deep/ .el-input__inner {
		border: none;
		border-radius: 0 8px 8px 0;
		box-shadow: none;
	}
}

.country-select {
	display: inline-block;
	width: 100%;
	vertical-align: middle;

	&.el-select {
		width: 100%;
	}

	/deep/ .el-input {
		width: 100%;
	}

	/deep/ .el-input__inner {
		width: 100%;
		border: none;
		height: 44px;
		line-height: 44px;
		padding: 0 2px 0 22px;
		font-size: 13px;
		text-align: center;
		color: #6b7280;
		background: transparent;
		border-radius: 0;
		box-sizing: border-box;
	}

	/deep/ .el-input__suffix {
		right: -20px;
		width: 16px;
	}

	/deep/ .el-input__icon {
		width: 12px;
		line-height: 44px;
	}
}

.input-with-send {
	/deep/ .el-input__inner {
		border-radius: 8px 0 0 8px;
		border-right: none;
	}
}

.input-with-pass {
	/deep/ .el-input__inner {
		padding-right: 44px;
		border-radius: 8px;
	}
}

.password-eye {
	width: 18px;
	height: 18px;
	margin-top: 13px;
	margin-right: 12px;
	cursor: pointer;
}

.el-input_search {
	display: flex;
	align-items: center;
	padding: 8px 12px;
	border-bottom: 1px solid #e5e7eb;

	img {
		width: 14px;
		height: 14px;
		margin-right: 8px;
	}

	.el-input__inner {
		border: none !important;
		height: 32px;
		padding: 0;
		background: none;
	}
}

.auth-submit {
	width: 100%;
	height: 44px;
	margin-top: 4px;
	background: #b50604 !important;
	border-color: #b50604 !important;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 500;
	color: #fff !important;
}

.auth-terms {
	margin-top: 20px;
	font-size: 12px;
	line-height: 20px;
	text-align: center;
	color: #6b7280;
	letter-spacing: normal;
	word-spacing: normal;
	white-space: normal;

	span {
		display: inline;
		letter-spacing: normal;
		word-spacing: normal;
	}
}

.auth-link {
	color: #b50604;
	cursor: pointer;
	margin: 0 2px;
}

@media screen and (max-width: 900px) {
	.login-lang-switch {
		top: 16px;
		right: 16px;
	}

	.auth-layout {
		flex-direction: column;
	}

	.auth-brand {
		flex: none;
		max-width: none;
		width: 100%;
		min-height: 240px;
		padding: 32px 24px;
	}

	.auth-brand__slogan {
		font-size: 22px;
	}

	.auth-main {
		width: 100%;
		padding: 32px 16px 48px;
	}

	.auth-tabs span {
		white-space: normal;
		font-size: 13px;
	}
}
</style>

<style lang="less">
.login-lang-dropdown {
	min-width: 120px !important;
	padding: 6px 0;
	border: none;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
	.el-dropdown-menu__item {
		padding: 8px 20px;
		font-size: 14px;
		line-height: 22px;
		color: #000;
		letter-spacing: normal;
		&:hover,
		&:focus {
			background: #B50604;
			color: #fff;
		}
		&.active {
			font-weight: 500;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue